import React from 'react'
import { ReactComponent as HamburgerIcon } from 'assets/svg/hamburger.svg';

export default function Hamburger({ sidebarOpen, setSidebarOpen }) {
  return (
    <HamburgerIcon className={`hamburger ${sidebarOpen ? "hamburger--trans" : ""}`} onClick={() => setSidebarOpen(!sidebarOpen)}/>
  )
}
